"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormPreviewEntryModule = /** @class */ (function () {
    function FormPreviewEntryModule() {
    }
    return FormPreviewEntryModule;
}());
exports.FormPreviewEntryModule = FormPreviewEntryModule;
